export enum SocketMessages {
    TIME_SYNC = 'sync_time',
    CLIENT_COUNT = 'client_count',
    NEW_CLIENT = 'new_client'
}